import { useCallback } from 'react'
import useSwr from 'swr'

type RelatedCoursesByAffinityData = {
  [courseSlug: string]: Array<{
    courseSlug: string
    affinityScore: number
  }>
}

const relatedCoursesByAffinityFixtureImportPromise = () =>
  import(
    /* webpackChunkName: "749u9017slmngu8uasdgx12549" */
    '@mc/growth-data/contentRanking/output/related-courses-by-affinity.json'
  )

const useRelatedCoursesByAffinityFixture = () =>
  useSwr('related-courses-by-affinity-fixture-client', () =>
    relatedCoursesByAffinityFixtureImportPromise().then(
      (m) => m.default as RelatedCoursesByAffinityData,
    ),
  )

export const useRelatedCoursesByAffinity = () => {
  const { data, isLoading, error } = useRelatedCoursesByAffinityFixture()

  const getRelatedCoursesByAffinity = useCallback(
    (courseSlug: string) =>
      data && data[courseSlug]?.map((entry) => entry.courseSlug),
    [data],
  )

  return { getRelatedCoursesByAffinity, isLoading, error }
}
